export const SUBSCRIPTION_TYPE = {
  Trial: 'Trial',
  Paid: 'Paid',
};

const SUBSCRIPTION_TYPE_MAPPING = [
  { value: SUBSCRIPTION_TYPE.Trial, label: 'Trial' },
  { value: SUBSCRIPTION_TYPE.Paid, label: 'Paid' },
];

export const getSubscriptionTypeLabel = value =>
  SUBSCRIPTION_TYPE_MAPPING.find(item => item.value === value)?.label || 'Not set';

export const getSubscriptionTypeOptions = () =>
  SUBSCRIPTION_TYPE_MAPPING.map(({ value, label }) => ({ value, label }));
